<rt-icon-button
  variant="plain"
  iconName="ai-vision"
  size="small"
  iconColor="colorIconStrongDefault"
  (click)="toggle()"
/>
